module.exports = __webpack_public_path__ + "img/klarna-rechnung.de1bac4.svg";